import {Injectable} from '@angular/core';
import {ApiRoutes} from "../../../../services/apiroutes";
import {RequestDetailModel} from "../../../../models/request-detail-model";
import {Subject} from "rxjs";
import {TermsAndConditionsModel} from "../../../../models/common/terms-and-conditions.model";
import {EmptyRepoQuoteModel, LeaseQuoteModel} from "../lease-quote-table/lease-quote";
import {BackendListModel} from "../../../../models/common/list.model";
import {DomainCode} from "../../../../models/common/model";
import {MatSnackBar} from "@angular/material/snack-bar";
import {RequestApiService} from "../../../../services/domain_code/request-api.service";
import {MatDialog} from "@angular/material/dialog";
import {DomainCodeApiService} from "../../../../services/domain_code/domain-code-api.service";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {
    SendEmailConfirmationComponent
} from "../../../dialog-box/send-email-confirmation/send-email-confirmation.component";
import {WarningBoxComponent} from "../../../dialog-box/warning-box/warning-box.component";
import {FailureBoxComponent} from "../../../dialog-box/failure-box/failure-box.component";

@Injectable({
    providedIn: 'root'
})
export class EmptyRepoQuoteTableService {

    base_url = ApiRoutes.LeadRequest;
    // quoteConfirmEmail_url = ApiRoutes.QuoteConfirmEmailUrl;
    selectedRequest: RequestDetailModel | any;
    review = new Subject<boolean>();
    disableSaveButton: boolean = false;
    termsAndCondition: TermsAndConditionsModel;
    termsConditionList: TermsAndConditionsModel[] = [];
    selectedTermsAndCondition: string = '';
    baseQuote: EmptyRepoQuoteModel;

    reviewAgreementPayload = [];
    dd_leaseOptions: any;
    dd_leaseUse: BackendListModel<DomainCode>;
    type: string = 'confirm';

    constructor(private snackBar: MatSnackBar,
                private requestService: RequestApiService,
                private dialog: MatDialog, private domainService: DomainCodeApiService,
                private http: HttpClient,
                private router: Router,
    ) {
    }

    saveQuotation() {
        this.disableSaveButton = true;
        this.baseQuote.terms_and_condition_fk = this.termsAndCondition;
        this.baseQuote.terms_and_condition_text = this.selectedTermsAndCondition;
        this.baseQuote.request = this.requestService.selectedRequest.id;

        this.baseQuote.pickup_schedules.map((item) => {
            item.client_id = item.id;
            item.port = item.port.id,
                item.requirement = item.requirement.id
        })
        this.baseQuote.dropoff_schedules.map((item) => {
            item.client_id = item.id;
            item.port = item.port.id,
                item.requirement = item.requirement.id
        })

        this.requestService.postQuotations(this.baseQuote.getEmptyRepoQuotePayload()).subscribe({
            next: response => {
                this.snackBar.open('Quotations saved', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log('postQuotations', response);
                this.review.next(null);
                window.location.reload();
                return response;
            },
            error: err => {
                this.review.next(false);
                if (err.status >= 500) {
                    this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                    return err;
                } else if (err.status > 399 && err.status < 500) {
                    this.baseQuote.patchErrors(err.error);
                    if (err.error.lease_agreement) {
                        this.openWarning('Before Confirming the deal, you need to complete all mandatory details associated to the lease contract', '', 'I Understand');
                    }
                    return err;
                }
            }
        });
    }


    confirmBooking(empty_repo_quote_for_post, remarks) {
        let chargeMasterPayload = [];
        let temp_ad_hoc_charges = this.baseQuote.ad_hoc_charges;
        this.disableSaveButton = true;
        this.baseQuote.request = this.requestService.selectedRequest.id;
        this.baseQuote.quote_items = empty_repo_quote_for_post.quote_items;
        this.baseQuote.pickup_schedules = empty_repo_quote_for_post.pickup_schedules;
        this.baseQuote.dropoff_schedules = empty_repo_quote_for_post.dropoff_schedules;
        this.baseQuote.quote_valid_till = empty_repo_quote_for_post.quote_valid_till;
        this.baseQuote.remarks = remarks;
        this.baseQuote.terms_and_condition_fk = empty_repo_quote_for_post.terms_and_condition_fk;
        this.baseQuote.terms_and_condition_text = empty_repo_quote_for_post.terms_and_condition_text;
        this.baseQuote.uploaded_documents = empty_repo_quote_for_post.uploaded_documents ? empty_repo_quote_for_post.uploaded_documents.map(item => item.id) : [];

        if (empty_repo_quote_for_post.ad_hoc_charges.length != 0) {
            empty_repo_quote_for_post.ad_hoc_charges.map(charge => {
                chargeMasterPayload.push({
                    quote_charge: charge.quote_charge.id,
                    amount: charge.amount,
                    amount_currency: charge.amount_currency
                });
            })
        }
        this.baseQuote.ad_hoc_charges = chargeMasterPayload;

        console.log('confirmBooking', this.baseQuote);

        this.requestService.confirmEmptyRepoBooking(this.baseQuote).subscribe({
            next: response => {
                this.snackBar.open('Booking Confirmed', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log('postQuotations', response);
                this.baseQuote.ad_hoc_charges = temp_ad_hoc_charges;
                this.openSendQuoteConfirmationDialog(response['latest_quote_id'], 'lease', 'Smart contract shared on email', 'booking');
                this.review.next(null);
                // window.location.reload();
                return response;
            },
            error: err => {
                this.baseQuote.uploaded_documents = empty_repo_quote_for_post.uploaded_documents;
                this.baseQuote.ad_hoc_charges = temp_ad_hoc_charges;
                this.review.next(false);
                if (err.status >= 500) {
                    this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                    return err;
                } else if (err.status > 399 && err.status < 500) {
                    this.baseQuote.patchErrors(err.error);
                    if (err.error.lease_agreement) {
                        this.openWarning('Before Confirming the deal, you need to complete all mandatory details associated to the lease contract', '', 'I Understand');
                    } else if ('requestor' in err.error) {
                        let label = 'Customer KYC Pending'
                        let desc = ''
                        err.error.requestor.forEach(item => {
                            desc += `• ${item}\n`
                        })
                        this.openDialogOnError(label, desc)
                    }
                    return err;
                }
            }
        });
    }

    openSendQuoteConfirmationDialog(quoteId, type, snackBarMessage, mailType): void {
        let htmlContent: string = '';
        this.requestService.getQuoteContentForEmail(quoteId, type, mailType).subscribe(
            (response: string) => {
                htmlContent = response;
                const dialogData = {
                    usersList: [this.requestService.selectedRequest.requestor?.email],
                    userListKey: '',
                    contentURL: ApiRoutes.QuoteConfirmEmailUrl,
                    contentKeys: {
                        to_emails: '',
                        subject: (mailType == 'quote' ? 'Quote is ready for Request No: ' : 'Booking Confirmed for Request No: ') + this.requestService.selectedRequest.request_number,
                        content: htmlContent
                    },
                    mailType: mailType,
                    snackBarMessage: snackBarMessage
                };
                const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
                    width: '80%', // Set the width of the dialog
                    disableClose: true,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        console.log('User clicked Yes');
                        this.disableSaveButton = false;
                    } else {
                        this.disableSaveButton = false;
                    }
                    window.location.reload();
                });

                dialogRef.componentInstance.emailSend.subscribe(() => {
                    window.location.reload();
                    // this.closeReview.emit(true);
                });
            },
            (error) => {
                console.error('Error fetching HTML content:', error);
            }
        );
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }

    openDialogOnError(label, description) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, description: description}
        });

        dialogRef.afterClosed().subscribe(item => {
            let baseUrl = window.location.href.replace(this.router.url, '');
            window.open(`${baseUrl}/master-data/customer-master?id=${this.requestService.selectedRequest.requestor?.company?.id}`, '_blank')
        })
    }

    confirmEmptyRepoBooking(quote: any) {
        this.requestService.confirmEmptyRepoBooking(quote).subscribe({
            next: response => {
                this.snackBar.open('Booking Confirmed', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log('postQuotations', response);
                this.openSendQuoteConfirmationDialog(response['latest_quote_id'], 'empty_repo', 'Smart contract' +
                    ' shared on email', 'booking');
                this.review.next(null);
                // window.location.reload();
                return response;
            },
            error: err => {
                this.review.next(false);
                if (err.status >= 500) {
                    this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                    return err;
                } else if (err.status > 399 && err.status < 500) {
                    this.baseQuote.patchErrors(err.error);
                    if (err.error.lease_agreement) {
                        this.openWarning('Before Confirming the deal, you need to complete all mandatory details associated to the lease contract', '', 'I Understand');
                    } else if ('requestor' in err.error) {
                        let label = 'Customer KYC Pending'
                        let desc = ''
                        err.error.requestor.forEach(item => {
                            desc += `• ${item}\n`
                        })
                        this.openDialogOnError(label, desc)
                    } else if ('sales_person' in err.error) {
                        this.openWarning('Enter the sales person name to proceed further.', '', 'Ok');
                    }
                    return err;
                }
            }
        });
    }
}
